import SmartTipCTA from './SmartTipCTA';

export default SmartTipCTA;
